import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import "./table.css"
import Checkbox from '@mui/material/Checkbox';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


export default function CustomizedTables(props) {
    const {data} = props
    return (
        data?.length > 0 &&
            <table className={"table"} style={{width:"99%" , marginTop:"5px"}} aria-label="customized table">
                <thead>
                    <tr>
                        <th sx={{ textAlign:"right"}}>{props.title || "عنوان"}</th>
                        <th sx={{ textAlign:"right"}}>{props.keyItem || "کلید"}</th>
                        <th sx={{ textAlign:"center"}}>حذف</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row , index) => (
                        <tr key={row.value}>
                            <td sx={{ textAlign:"right"}} component="th" scope="row">
                                <div dangerouslySetInnerHTML={{__html: row.question || row.title }}/>
                            </td>
                            <td sx={{ textAlign:"right"}}>
                                <div dangerouslySetInnerHTML={{__html: row.answer || row.value }}/>
                            </td>
                            <td  onClick={() => {props.onDelete(index)}} sx={{ textAlign:"center" , cursor:"pointer"}}>
                                حذف
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
    );
}